import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
export default function PlaceholderDots() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      className: "jsx-2880358364" + " " + 'dots',
      children: "\xB7\xB7\xB7\xB7"
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2880358364",
      children: [".dots.jsx-2880358364{font-weight:700;-webkit-letter-spacing:0.125rem;-moz-letter-spacing:0.125rem;-ms-letter-spacing:0.125rem;letter-spacing:0.125rem;}"]
    })]
  });
}